export default "__VITE_ASSET__BpzoJSCg__"